var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31px",
    height: "36px",
    viewBox: "0 0 31 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "All-Categories",
    transform: "translate(-1745.000000, -20.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(1746.521859, 21.599325)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    stroke: "#F05F4B",
    strokeWidth: 2,
    points: "2 5.40067465 18 5.40067465 20 25.9006747 0 25.9006747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.98088909,4.5 C5.98088909,2.01464151 7.78135131,0 10.0024879,0 C12.2236246,0 14.0240868,2.01464151 14.0240868,4.5",
    id: "Stroke-1",
    stroke: "#F05F4B",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F05F4B",
    cx: 20.2570092,
    cy: 25.179543,
    r: 8.77886838
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIc);
export default __webpack_public_path__ + "static/media/cart-ic.1372f196547802ebe179068dc75629b0.svg";
export { ForwardRef as ReactComponent };